import React, { useState, useEffect } from 'react';
import { useThemeMode } from '../../ThemeContext';
import UserProfile from './UserProfile';
import CompanyProfile from './CompanyProfile';
import EditIcon from '@mui/icons-material/Edit';
import './Profile.css';

const Profile = () => {
  const { mode } = useThemeMode();
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleUserDataUpdate = (updatedUserData) => {
    setUserData(updatedUserData);
  };

  useEffect(() => {
    const getUserData = () => {
      try {
        const userDataFromStorage = localStorage.getItem('userData');
        if (userDataFromStorage) {
          const user = JSON.parse(userDataFromStorage);
          setUserData(user);
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    getUserData();
  }, []);

  if (isLoading) {
    return (
      <div
        className="profile-page"
        style={{
          padding: '24px',
          backgroundColor: mode === 'dark' ? '#0f0f0f' : '#ffffff',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div style={{
          color: mode === 'dark' ? '#fff' : '#333',
          fontSize: '18px',
          fontFamily: 'Urbanist, Arial, sans-serif'
        }}>
          Loading profile...
        </div>
      </div>
    );
  }

  if (!userData) {
    return (
      <div
        className="profile-page"
        style={{
          padding: '24px',
          backgroundColor: mode === 'dark' ? '#0f0f0f' : '#ffffff',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div style={{
          color: mode === 'dark' ? '#fff' : '#333',
          fontSize: '18px',
          fontFamily: 'Urbanist, Arial, sans-serif'
        }}>
          No user data found. Please log in again.
        </div>
      </div>
    );
  }

  return (
    <div
      className="profile-page"
      style={{
        padding: '24px',
        backgroundColor: mode === 'dark' ? '#0f0f0f' : '#ffffff',
        minHeight: '100vh',
        fontFamily: 'Urbanist, Arial, sans-serif'
      }}
    >
      {/* Admin Profile Section */}
      <UserProfile userData={userData} mode={mode} onUserDataUpdate={handleUserDataUpdate} />

      {/* Company Profile Section - Only show if company_type is "company" */}
      {userData.company_type === 'company' && (
        <CompanyProfile userData={userData} mode={mode} onUserDataUpdate={handleUserDataUpdate} />
      )}
    </div>
  );
};

export default Profile;
